import { CalendarModificationGeneratedEntity } from "./generated/CalendarModificationGeneratedEntity";
import { PlanningEventEntity } from "./PlanningEventEntity";

export enum CalendarModificationType {
    Unknown = 0,
    ExceptionalWorkingDay = 1,
    Holiday = 2,
    Disruption = 3,
    Vacation = 4,
}

export enum CalendarDisruptionType {
    Weather = "Weather",
    SupplyDelay = "SupplyDelay",
    ConstructionAccident = "ConstructionAccident",
    AdministrativeBlock = "AdministrativeBlock",
    Other = "Other",
}
export interface CalendarModificationRelation {
    relatedEvents: ReadonlyArray<PlanningEventEntity>;
    calendarModification: CalendarModificationEntity;
}

export enum DurationType {
    CalendarDays = 0,
    WorkingDays = 1,
}

export abstract class CalendarModificationEntity extends CalendarModificationGeneratedEntity {
    public abstract durationType: DurationType;

    public abstract calendarModificationType: CalendarModificationType;

    public get relatedEvents(): ReadonlyArray<PlanningEventEntity> {
        if (this.isProjectScopeRelated) {
            return this.project.planningEvents;
        }
        return this.planningEventRelations.flatMap((relation) => relation.relatedEvents);
    }
}
